import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import config from "../config";
import keycloak from '../keycloak'
import { refreshAccessToken } from './apiClient'

const supportClient = axios.create({
  baseURL: config.supportPalUrl,
  headers:{
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

supportClient.interceptors.request.use(
  async (requestConfig: InternalAxiosRequestConfig) => {
    if (keycloak?.authenticated) {
      await refreshAccessToken(60)
    }

    if (keycloak?.token) {
      requestConfig.headers.Authorization = `Bearer ${keycloak.token}`
    }

    return requestConfig
  },
  error => Promise.reject(error)
)

// Текст помилки SupportPal для viewAlert; 401/403 та мережеві помилки — загальне повідомлення
export const getSupportPalErrorMessage = (err: AxiosError<any>, t: (key: string) => string): string => {
  const status = err?.response?.status
  const data = err?.response?.data

  if (!err?.response || status === 401 || status === 403) {
    return t('SUPPORT_UNAVAILABLE')
  }

  return data?.detail || data?.message || t('SUPPORT_UNAVAILABLE')
}

const items = ['','','','','','','','','true','','','','','','','']; // Ваш массив
const index = 8; // Индекс элемента, который вы хотите отметить

const getResponseItems = (response:any) => Array.isArray(response?.data?.data) ? response.data.data : []

const getDepartments = (brandId:string | number | null = 1) => {
  if (!brandId) {
    return supportClient.get('ticket/department')
  }

  return supportClient.get('ticket/department', { params: { brand_id: brandId } })
    .then((response) => getResponseItems(response).length > 0 ? response : supportClient.get('ticket/department'))
    .catch(() => supportClient.get('ticket/department'))
}


const supportPalService = {
  getTicketById:(ticketId:string) => supportClient.get(`ticket/ticket/${ticketId}`),
  editTicketById:(ticketId:string, data:Object) => supportClient.put(`ticket/ticket/${ticketId}`, data),
  getTicketMessagesById:(ticketId:string) => supportClient.get(`ticket/message?ticket_id=${ticketId}`),
  getTicketList:(queries:any) => supportClient.get(`ticket/ticket`, {
    params:{
      ...queries,
      
      // order_column:'created_at'
    }
  }),
  getTicketListCluster:(queries:any) => supportClient.get(`ticket/ticket`, {
    params:{
      ...queries,
      [`customfield[${index}]`]: items[index]
      // order_column:'created_at'
    }
  }),
  createTicket:(data:Object) => supportClient.post('ticket/ticket', data),
  getDepartments,
  getPriority:() => supportClient.get('ticket/priority'),
  getStatus:() => supportClient.get('ticket/status'),
  addMessageToTicket:(data:Object) => supportClient.post(`ticket/message`, data),
  downloadAttachment:(attachmentId:any) => supportClient.get(`ticket/attachment/${attachmentId}/download`),
  getCustomFields:() => supportClient.get('ticket/customfield')
}

export default supportPalService
